// Auto-generated by scripts/set-app-version.js
// Do not edit manually - this file is regenerated on each build

export const appVersionRaw = "3.5.10";
export const sentryReleaseJepto = "jepto-web@3.5.10+dev.56c1b8d5399c";
export const sentryReleaseAnalytics = "jepto-analytics@3.5.10+dev.56c1b8d5399c";
